export const isFirefox = () =>
  typeof navigator !== 'undefined' && /Firefox\//i.test(navigator.userAgent);

export const isSafari = () =>
  typeof navigator !== 'undefined' &&
  /Safari\//i.test(navigator.userAgent) &&
  !/Chrome\//i.test(navigator.userAgent);

export const supportsDeviceSelection = () => !isFirefox() && !isSafari();

export const inputDeviceId = () => {
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('audioInputDeviceId') : null;
  return saved || 'default';
};

export const outputDeviceId = () => {
  if (supportsDeviceSelection()) {
    const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('audioOutputDeviceId') : null;
    return saved || 'default';
  } else {
    return 'default';
  }
};
